import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_L2_MENU_CHR } from "../../../../utils/routes";

// ---------------------------------------------------------------------

export const createL2MenuChr = createAsyncThunk(
  "l2MenuChr/createL2MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_L2_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getL2MenuChr = createAsyncThunk(
  "l2MenuChr/getL2MenuChr",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_L2_MENU_CHR, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const getL2MenuChrByL1Menu = createAsyncThunk(
  "l2MenuChr/getL2MenuChrByL1Menu",
  async (id) => {
    return axios.get(`${CURD_L2_MENU_CHR}/${id}`, { withCredentials: true });
  }
);

export const updateL2MenuChr = createAsyncThunk(
  "l2MenuChr/updateL2MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_L2_MENU_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteL2MenuChr = createAsyncThunk(
  "l2MenuChr/deleteL2MenuChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_L2_MENU_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const l2MenuChrSlice = createSlice({
  name: "l2MenuChr",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    l2MenuData: [],
    l2SelectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.l2SelectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createL2MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createL2MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createL2MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getL2MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getL2MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2MenuData = action?.payload?.data;
    },
    [getL2MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [getL2MenuChrByL1Menu.pending]: (state, action) => {
      state.loading = true;
    },
    [getL2MenuChrByL1Menu.fulfilled]: (state, action) => {
      state.loading = false;
      state.l2MenuChrData = action?.payload?.data;
    },
    [getL2MenuChrByL1Menu.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateL2MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateL2MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateL2MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteL2MenuChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteL2MenuChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteL2MenuChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  l2MenuChrSlice.actions;
export default l2MenuChrSlice.reducer;
